export class CFilePrefix {
    static readonly OBSERVATION_PREFIX = 'OBSERVATION';
    static readonly SETTINGS_PREFIX = 'SETTING';
    static readonly PULSES_PREFIX   = 'PULSE';
    static readonly COMMAND_PREFIX  = 'COMMAND';
    static readonly ARGUMENT_PREFIX = '_ARG_';
    static readonly ENUMERATION_PREFIX  = 'ENUM';
}